<!-- Webhook Setting -->
<template>
	<div class="card">
		<div class="card-body">
			<h4 class="header-title mb-2">{{ $t('Settings.heading') }}</h4>
			<div class="form-field">
				<span>Webhook URL</span>
				<input
					v-model="attributes.webhookUrl"
					class="form-control input-primary"
				/>
			</div>
			<div class="form-field">
				<span>Webhook Bearer Token</span>
				<input
					v-model="attributes.webhookBearerToken"
					class="form-control input-primary"
				/>
			</div>
			<div class="form-field">
				<button class="btn btn-primary" @click="submitWebhookSetting">
					Submit
				</button>
			</div>
			<div
				v-if="!loading && submitSuccess"
				class="alert alert-success text-center font-weight-bold"
				role="alert"
			>
				<i class="mdi mdi-checkbox-marked-circle-outline mr-2" />
				<span>{{ $t('Settings.msg_validation_success') }}</span>
			</div>
			<ApiErrorAlert v-if="!loading && error" :error="error" />
		</div>
	</div>
</template>

<script>
import ApiErrorAlert from '@/components/ApiErrorAlert'
import { authComputed, configComputed } from '@/store/helpers'
import axiosApiClient from '@/api/axiosApiClient'
import { displayDatetime } from '@/utils/helpers'

export default {
	components: { ApiErrorAlert },
	i18nOptions: { keyPrefix: 'PORTAL' },
	props: {
		user: {
			type: Object,
			required: false,
			default: () => null
		}
	},
	data() {
		return {
			attributes: {
				webhookUrl: '',
				webhookBearerToken: ''
			},
			loading: false,
			error: '',
			submitSuccess: false
		}
	},
	computed: {
		...authComputed,
		...configComputed
	},
	created() {
		this.$store.subscribe((mutation, state) => {
			if (mutation.type === 'config/SET_LOCALE') {
				// trigger changeFormat to get templateUrl base on locale change
				this.changeFormat({ formatId: this.formatId })
			}
		})
	},
	mounted() {
		this.fetchWebhook()
	},
	methods: {
		async fetchWebhook() {
			if (!this.loading) {
				try {
					this.loading = true
					const { data } = await axiosApiClient.get(
						`clients/webhook/` + this.user.clientId
					)
					this.loading = false
					if (data) {
						this.attributes.webhookUrl = data.webhookUrl
							? data.webhookUrl
							: ''
						this.attributes.webhookBearerToken =
							data.webhookBearerToken
								? data.webhookBearerToken
								: ''
					}
				} catch (error) {
					this.loading = false
					this.error = error
				}
			}
		},
		async submitWebhookSetting() {
			if (!this.loading) {
				try {
					this.loading = true
					const { data } = await axiosApiClient.patch(
						`clients/webhook/` + this.user.clientId,
						{
							attributes: this.attributes
						}
					)
					this.loading = false
					this.submitSuccess = true
					console.log(data)
				} catch (error) {
					this.loading = false
					this.error = error
				}
			}
		}
	}
}
</script>

<style scoped>
div.dropzone-container {
	position: relative;
}
div.dropzone-overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	border-radius: 6px;
	background: rgba(0, 0, 0, 0.25);
	cursor: not-allowed;
}
div.form-field {
	margin-bottom: 20px;
}
</style>
